module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0 pa-4 py-6",
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [(!_vm.showInfo) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    attrs: {
      "text": "",
      "border": "left",
      "type": "info",
      "icon": "info",
      "dense": "dense"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-600"
  }, [_vm._v(" Requerimiento de cambio de contraseña")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("  Te enviaremos un link con las instrucciones para restablecer tu contraseña.")])])]), _c('v-form', [_c('v-text-field', {
    ref: "usuarioResetPassword",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Ingresa un usuario valido (email)",
      "type": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.fetchRestablecerContraseña()
      }
    }
  }, [_c('small', [_vm._v("Continuar")])])], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center mt-4"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("¿Deseas Iniciar sesión?")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "small",
      "color": "secondary primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_vm._v("click aquí")])], 1)], 1) : _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-alert', {
    attrs: {
      "color": "success",
      "text": "text",
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-15 font-weight-700 mb-1"
  }, [_vm._v("¡Casi terminamos!")]), _c('small', {
    staticClass: "font-size-12 mt-2"
  }, [_vm._v(" Consulta tu correo electrónico, te hemos enviado las instrucciones necesarias para recuperar tu contraseña.")])])]), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "block": "block",
      "color": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_c('small', [_vm._v("Iniciar sesión")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d65c577","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forgot_password_request.vue
// module id = 502
// module chunks = 1